import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Navbar from "./components/Navbar";
import Products from "./pages/Products";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";
import ContactUs from "./pages/contactUs";
import HospitalCubicalCurtains from "./productDetails/hospitalCubicalCurtains";
import BedHeadPanel from "./productDetails/BedHeadPanel";
import GasOutletPoint from "./productDetails/GasOutletPoint";
import GasOutlet from "./productDetails/GasOutlet";
import WardVacuumUnit from "./productDetails/WardVacuumUnit";
import TheatreSuctionTrolley from "./productDetails/TheatreSuctionTrolley";
import OxygenFlowMeter from "./productDetails/OxygenFlowMeter";
import FlowMeter from "./productDetails/FlowMeter"; 
import AreaValveBox from "./productDetails/AreaValveBox"; 
import AreaAlarmA from "./productDetails/AreaAlarmA";
import AreaAlarmD from "./productDetails/AreaAlarmD";
import GasTerminal from "./pages/GasTerminal"; 
import SuctionDevices from "./pages/SuctionDevices";
import ZonalAccessories from "./pages/ZonalAccessories";
import OperationTheatre from "./pages/OperationTheatre";
import FixedSurgicalPandant from "./otProducts/FixedSurgicalPandant";
import SingleArmSurgicalPandant from "./otProducts/SingleArmSurgicalPandant";
import DoubleArmSurgicalPandant from "./otProducts/DoubleArmSurgicalPandant";
import FixedAnestheticPandant from "./otProducts/FixedAnestheticPandant";
import SingleArmAnestheticPandant from "./otProducts/SingleArmAnestheticPandant";
import DoubleArmAnestheticPandant from "./otProducts/DoubleArmAnestheticPandant";
import ModularFixedPandant from "./otProducts/ModularFixedPandant";
import ModularSingleArmPandant from "./otProducts/ModularSingleArmPandant";
import ModularDoubleArmPandant from "./otProducts/ModularDoubleArmPandant";
import ModularElectricSingleArmPandant from "./otProducts/ModularElectricSingleArmPandant";
import ModularElectricDoubleArmPandant from "./otProducts/ModularElectricDoubleArmPandant"; 
import WallCard from "./otProducts/WallCard";
import CornerCard from "./otProducts/CornerCard";
import SSScrubSink from "./otProducts/SSScrubSink";
import LaminarAirFlow from "./otProducts/LaminarAirFlow";
import ModularHatchBox from "./otProducts/ModularHatchBox";
import HarmeticSealSwingerDoor from "./otProducts/HarmeticSealSwingerDoor";
import HarmeticallySealedSlidingDoor from "./otProducts/HarmeticallySealedSlidingDoor";
import ControlPanel from "./otProducts/ControlPanel";
import SurgeonControlPanel from "./otProducts/SurgeonControlPanel";
import XRayBoard from "./otProducts/XRayBoard";
import WritingBoard from "./otProducts/WritingBoard";
import PeripheralLight from "./otProducts/PeripheralLight";
import PressureReliefDamper from "./otProducts/PressureReliefDamper";
import CurtainTrackSystem from "./otProducts/CurtainTrackSystem";
import NurseCallSystem from "./otProducts/NurseCallSystem";



export default function App() {
  return (
    <Router>
      
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/hospitalCubicalCurtains" element={<HospitalCubicalCurtains />} />
          <Route path="/bedHeadPanel" element={<BedHeadPanel />} />
          <Route path="/gas-Outlet-Point" element={<GasOutletPoint />} />
          <Route path="/gas-Outlet" element={<GasOutlet />} />
          <Route path="/ward-vacuum-unit" element={<WardVacuumUnit />} />
          <Route path="/theatre-suction-trolley" element={<TheatreSuctionTrolley />} />
          <Route path="/oxygen-flow-meter" element={<OxygenFlowMeter />} />
          <Route path="/flow-meter" element={<FlowMeter />} />
          <Route path="/area-valve-box" element={<AreaValveBox />} />
          <Route path="/area-alarm-analog" element={<AreaAlarmA />} />
          <Route path="/area-alarm-digital" element={<AreaAlarmD />} /> 
          <Route path="/gas-terminal" element={<GasTerminal />} />
          <Route path="/suction-devices" element={<SuctionDevices />} />
          <Route path="/zonal-accessories" element={<ZonalAccessories />} />
          <Route path="/operation-theatre" element={<OperationTheatre />} />
          <Route path="/fixed-surgical-pandant" element={<FixedSurgicalPandant />} />
          <Route path="/single-arm-surgical-pandant" element={<SingleArmSurgicalPandant />} />
          <Route path="/double-arm-surgical-pandant" element={<DoubleArmSurgicalPandant />} />
          <Route path="/fixed-anesthetic-pandant" element={<FixedAnestheticPandant />} />
          <Route path="/single-arm-anesthetic-pandant" element={<SingleArmAnestheticPandant />} />
          <Route path="/double-arm-anesthetic-pandant" element={<DoubleArmAnestheticPandant />} />
          <Route path="/modular-fixed-pandant" element={<ModularFixedPandant />} />
          <Route path="/modular-single-arm-pandant" element={<ModularSingleArmPandant />} />
          <Route path="/modular-double-arm-pandant" element={<ModularDoubleArmPandant />} />
          <Route path="/modular-electric-single-arm-pandant" element={<ModularElectricSingleArmPandant />} />
          <Route path="/modular-electric-double-arm-pandant" element={<ModularElectricDoubleArmPandant />} />
          <Route path="/wall-card" element={<WallCard />} />
          <Route path="/corner-card" element={<CornerCard />} />
          <Route path="/ss-scrub-sink" element={<SSScrubSink />} />
          <Route path="/laminar-air-flow" element={<LaminarAirFlow />} />
          <Route path="/modular-hatch-box" element={<ModularHatchBox />} />
          <Route path="/hermetic-seal-swinger-door" element={<HarmeticSealSwingerDoor />} />
          <Route path="/hermetically-sealed-sliding-door" element={<HarmeticallySealedSlidingDoor />} />
          <Route path="/control-panel" element={<ControlPanel />} />
          <Route path="/surgeon-control-panel" element={<SurgeonControlPanel />} />
          <Route path="/x-ray-board" element={<XRayBoard />} />
          <Route path="/writing-board" element={<WritingBoard />} />
          <Route path="/peripheral-light" element={<PeripheralLight />} />
          <Route path="/pressure-relief-damper" element={<PressureReliefDamper />} />
          <Route path="/curtain-track-system" element={<CurtainTrackSystem />} />
          <Route path="/nurse-call-system" element={<NurseCallSystem />} />

        </Routes>
        <Footer />
      
    </Router>
  );
}
